export const calculateWinData = (againstNumbersLength, selectedNumbersLength, n, amount) => {
    let calculatedLines = 0;
    let minimumWin = 0;
    let price = 0;
    let maximumWin = 0;

    if (againstNumbersLength === 1  && selectedNumbersLength >= 1 && selectedNumbersLength <= 24) {
        calculatedLines = selectedNumbersLength;
        price = selectedNumbersLength * amount;
        minimumWin = amount * 220;

        if (selectedNumbersLength > 1 && selectedNumbersLength >= 7) {
            maximumWin = 1320 * amount;
        } else {
            maximumWin = calculatedLines * minimumWin;
        }
    } else if (againstNumbersLength === 2 && selectedNumbersLength >= 1 && selectedNumbersLength <= 24) {
        calculatedLines = selectedNumbersLength * 2;
        price = calculatedLines * amount;
        minimumWin = amount * 220;

        if (selectedNumbersLength >= 3) {
            maximumWin = amount * 1320 ;
        } else {
            maximumWin = calculatedLines * minimumWin;
        }  
      } else if (againstNumbersLength === 3   && selectedNumbersLength >= 1 && selectedNumbersLength <= 24) {
        calculatedLines = selectedNumbersLength * 3;
        price = calculatedLines * amount;
        minimumWin = amount * 220;

        if (selectedNumbersLength >= 2) {
            maximumWin = amount * 1320;
        } else {
            maximumWin = calculatedLines * minimumWin;
        } 
    }else if (againstNumbersLength === 4 && selectedNumbersLength >= 1 && selectedNumbersLength <= 24) {
        calculatedLines = selectedNumbersLength * 4;
        price = calculatedLines * amount;
        minimumWin = amount * 220;

        if (selectedNumbersLength >= 2) {
            maximumWin = amount * 1320 ;
        } else {
            maximumWin = calculatedLines * minimumWin;
        } 
    }else if (againstNumbersLength === 5 && selectedNumbersLength >= 1 && selectedNumbersLength <= 24) {
        calculatedLines = selectedNumbersLength * 5;
        price = calculatedLines * amount;
        minimumWin = amount * 220;

        if (selectedNumbersLength >= 2) {
            maximumWin = amount * 1320 ;
        } else {
            maximumWin = calculatedLines * minimumWin;
        } 
    }else if (againstNumbersLength === 6 && selectedNumbersLength >= 1 && selectedNumbersLength <= 24) {
        calculatedLines = selectedNumbersLength * 6;
        price = calculatedLines * amount;
        minimumWin = amount * 220;

        if (selectedNumbersLength >= 2) {
            maximumWin = amount * 1320 ;
        } else {
            maximumWin = calculatedLines * minimumWin;
        } 
    }

    return { calculatedLines, minimumWin, price, maximumWin };
};


export const calculateWinDataForLimit6To12 = (n, amount) => {
    let calculatedLines;

    if (n === 6) {
        calculatedLines = 6;
    } else if (n === 7) {
        calculatedLines = 21;
    } else if (n === 8) {
        calculatedLines = 56;
    } else if (n === 9) {
        calculatedLines = 126;
    } else if (n === 10) {
        calculatedLines = 256;
    } else if (n === 11) {
        calculatedLines = 462;
    } else if (n === 12) {
        calculatedLines = 792;
    } else {
        calculatedLines = 0;
    }

    const price = calculatedLines * amount;
    const minimumWin = amount * 38000;
    //const maximumWin = calculatedLines * 1800 * amount; // You can define maximumWin if needed.

    return { calculatedLines, minimumWin, price };
};

export const calculateWinDataForLimit4To17 = (n, amount) => {
    let calculatedLines;

    if (n === 4) {
        calculatedLines = 4;
    } else if (n === 5) {
        calculatedLines = 10;
    } else if (n === 6) {
        calculatedLines = 20;
    } else if (n === 7) {
        calculatedLines = 35;
    } else if (n === 8) {
        calculatedLines = 56;
    } else if (n === 9) {
        calculatedLines = 84;
    } else if (n === 10) {
        calculatedLines = 120;
    } else if (n === 11) {
        calculatedLines = 165;
    } else if (n === 12) {
        calculatedLines = 220;
    } else if (n === 13) {
        calculatedLines = 286;
    } else if (n === 14) {
        calculatedLines = 364;
    } else if (n === 15) {
        calculatedLines = 455;
    } else if (n === 16) {
        calculatedLines = 560;
    } else if (n === 17) {
        calculatedLines = 680;
    } else {
        calculatedLines = 0;
    }
    const price = calculatedLines * amount;
    const minimumWin = amount * 1800;
    const maximumWin = n <= 5 ? calculatedLines * 1800 * amount : 18000 * amount;

    return { calculatedLines, minimumWin, price, maximumWin };
};

export const calculateWinDataForLimit5To13 = (n, amount) => {
    let calculatedLines;
  
    if (n === 5) {
      calculatedLines = 5;
    } else if (n === 6) {
      calculatedLines = 15;
    } else if (n === 7) {
      calculatedLines = 35;
    } else if (n === 8) {
      calculatedLines = 70;
    } else if (n === 9) {
      calculatedLines = 126;
    } else if (n === 10) {
      calculatedLines = 210;
    } else if (n === 11) {
      calculatedLines = 330;
    } else if (n === 12) {
      calculatedLines = 495;
    } else if (n === 13) {
      calculatedLines = 715;
    } else {
      calculatedLines = 0;
    }
  
    const price = calculatedLines * amount;
    const minimumWin = amount * 4500;
  
    return { calculatedLines, minimumWin, price };
  };
